#import '../../../../../field/fragments/eav-fragment.graphql'

fragment LeadGoalFragment on LeadStagesEdge {
    node {
        id
    }
    isActive
    goalConditions {
        condition {
            id
            humanReadableObjectiveString
            type
        }
        status
        conditionCustomField {
            node {
                ...EntityAttribute
            }
            value {
                ...EntityAttributeValue
            }
        }
    }
}
